import React, { FC } from "react";
import { Button } from "component-library";
import { dataTestIds } from "data-testids";
import LabelValueRow from "components/LabelValueRow/LabelValueRow";

type SettingSectionProps = {
  sectionHeader?: string;
  sectionDescription: string;
  subSectionHeader?: string;
  sectionData?: {
    label: string;
    value?: (string | Date | React.JSX.Element) | React.JSX.Element[];
    isHidden?: boolean;
  }[];
  actionButtonLabel: string;
  actionButtonOnClick: () => void;
  actionButtonHidden?: boolean;
  actionButtonDisabled?: boolean;
};

const SettingSection: FC<React.PropsWithChildren<SettingSectionProps>> = ({
  sectionHeader,
  sectionDescription,
  subSectionHeader,
  sectionData,
  actionButtonLabel,
  actionButtonOnClick,
  actionButtonHidden,
  actionButtonDisabled = false,
  children,
}) => {
  return (
    <div className="py-4">
      <div className="mb-2">
        {sectionHeader && <h3 className="text-[26px]">{sectionHeader}</h3>}
        <p className="leading-6 md:leading-10">{sectionDescription}</p>
      </div>
      <hr className="mb-2" />
      <div className="flex flex-col gap-2 mb-2">
        {subSectionHeader && <h3 className="text-xxl">{subSectionHeader}</h3>}
        {sectionData?.map((item) => {
          if (item.isHidden) return null;

          return (
            <LabelValueRow
              key={item.label}
              label={item.label}
              value={item.value}
            />
          );
        })}
        {children}
      </div>
      {!actionButtonHidden && (
        <>
          <hr className="mb-2" />
          <div className="flex justify-end mt-4">
            <Button
              type="primary"
              text={actionButtonLabel}
              className="md:w-[315px] mt-6 md:mt-0"
              onClick={actionButtonOnClick}
              disabled={actionButtonDisabled}
              data-testid={
                dataTestIds.userAccountApp[
                  "AccountSettings.SettingSection.primaryButton"
                ]
              }
            />
          </div>
        </>
      )}
    </div>
  );
};

export default SettingSection;
